export default __webpack_public_path__ + "static/media/camara.a50397d7.png";